import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core'
import { BreadcrumbService } from '../shared-components/breadcrumb.service'
import { ActivatedRoute, Router } from '@angular/router'
import {
  UntypedFormControl,
  FormGroup,
  Validators,
  UntypedFormBuilder,
} from '@angular/forms'
import { CareFinityValidators } from '../../validators/CareFinityValidators'
import { MessageService, LazyLoadEvent, ConfirmationService, SortEvent } from 'primeng/api'
import { validateAllFormFields } from '../../../formUtils'
import {
  Patient,
  ArchiveTemplate,
  DataPageOfPatientPurge,
} from '../../../api/models'
import { PatientService, PatientArchiveService } from '../../../api/services'
import { DatePipe } from '@angular/common'
import { AppComponent } from 'src/app/app.component'
import { environment } from 'src/environments/environment'
import { NgxSpinnerService } from 'ngx-spinner'
import { Table } from 'primeng/table'
import { DataPageOfPatientArchive } from '../../../api/models/data-page-of-patient-archive'
import { filter } from 'rxjs'
import { Customsort } from '../../directives/customsort'
//import { DataPageOfPatientPurge } from '../../../api/models/DataPageOfPatientPurge';

@Component({
  selector: 'app-patient-archive',
  templateUrl: './patient-archive.component.html',
  styleUrls: ['./patient-archive.component.css'],
})
export class PatientArchiveComponent implements OnInit {
  [x: string]: any
  clinicalTemplate: ArchiveTemplate[]
  billingTemplate: ArchiveTemplate[]
  significantTemplate: ArchiveTemplate[]
  lastName: string
  firstName: string
  dOB: Date
  mRN: string
  archivePatients: DataPageOfPatientArchive = {}

  archivePatientPurge: DataPageOfPatientPurge = {}
  selectedClinical: []
  archiveForm
  archiverestoreForm
  showthreshholdClinical: boolean = false // default value
  showthreshholdBilling: boolean = false // default value
  archiveBy: string = 'Date' // default value
  billingBy: string = 'Date' // default value
  restoreBy: string = 'All' // default value
  private cols: { field: string; header: string }[]
  colspurge: { field: string; header: string }[]

  yearRangeForDatePicker: string
  Showrecords: boolean = false
  displaypatientRestoreDialog: boolean = false

  patientPurgeConfirmatiomDialog: boolean = false

  showrestoreDaterange: boolean = false
  startdate: string = ''
  enddate: string = ''
  confirmpatientarchiveDialogVisible = false
  selectedPatientArchiveId: number
  selectedPatientArchiveName: string
  billingSettings: string

  selectedRows: any[] = []
  ischecked: boolean = false

  patientRestorteConfirmatiomDialog: boolean = false
  patientRestortedSuccessMessage: boolean = false

  restorehButtonDisabled: boolean = false

  isPurgePatientTabActve: boolean = false
  isRestorePatientsActive: boolean = false
  configurationforAdultorPed: string = 'Adult'
  isEnablePedsConfigActive: boolean = false
  showRecordsArchivePatients: boolean = false
  showRecordsArchivePatientsPurge: boolean = false

  index: number = 1

  constructor(
    private fb: UntypedFormBuilder,
    private patientarchiveservice: PatientArchiveService,
    private messageService: MessageService,
    private datePipe: DatePipe,
      private confirmation: ConfirmationService,
      private customsort: Customsort,
  ) {}
  ngOnInit() {
    this.archiveForm = this.fb.group({
      billingArchiveByName: ['date', []],
      billingArchiveByNamePeds: new UntypedFormControl(null, []),
      billingArchiveByValue: new UntypedFormControl(null, []),
      billingArchiveByValuePeds: new UntypedFormControl(null, []),
      billingSettings: new UntypedFormControl(null, []),
      billingSettingsPeds: new UntypedFormControl(null, []),
      billingThreshHold: new UntypedFormControl(null, []),
      billingThreshHoldPeds: new UntypedFormControl(null, []),
      clinicalArchiveByName: ['date', []],
      clinicalArchiveByNamePeds: new UntypedFormControl(null, []),
      clinicalArchiveByValue: new UntypedFormControl(null, []),
      clinicalArchiveByValuePeds: new UntypedFormControl(null, []),
      clinicalArchiveThresholdPeds: new UntypedFormControl(null, []),
      clinicalSettings: new UntypedFormControl(null, []),
      clinicalSettingsPeds: new UntypedFormControl(null, []),
      clinicalThreshHold: new UntypedFormControl(null, []),
      daysPriorTo: new UntypedFormControl(null, []),
      enablePedsConfig: new UntypedFormControl(null, []),
      isAdult: new UntypedFormControl(true, []),
      isArchiveExpiredPatients: new UntypedFormControl(null, []),
      isPeds: new UntypedFormControl(false, []),
      isPurgePatients: new UntypedFormControl(false, []),
      isRestorePatients: new UntypedFormControl(null, []),
      pedsAge: new UntypedFormControl(null, []),
      purgeThreshold: new UntypedFormControl(null, []),
      significantSettings: new UntypedFormControl(null, []),
      significantSettingsPeds: new UntypedFormControl(null, []),
      significantValue: new UntypedFormControl(null, []),
      significantValuePeds: new UntypedFormControl(null, []),
    })

    this.archiverestoreForm = this.fb.group({
      restorebyAll: new UntypedFormControl('all', []),
    })

    this.yearRangeForDatePicker = environment.yearRangeForDatePicker

    this.cols = [
      { field: 'lastName', header: 'Last Name' },
      { field: 'firstName', header: 'First Name' },
      { field: 'mrn', header: 'Mrn' },
      { field: 'formattedDOB', header: 'DOB' },
      { field: 'formattedArchiveDate', header: 'Archive Date' }


     
    ]
    this.colspurge = [
      { field: 'lastName', header: 'Last Name' },
      { field: 'lastName', header: 'Last Name' },
      { field: 'lastName', header: 'First Name' },
      { field: 'mrn', header: 'Mrn' },
      { field: 'dob', header: 'DOB' },
    ]
    this.loadTemplates()

    this.archiveForm.get('isPurgePatients').valueChanges.subscribe((item) => {
      console.log('Checkbox value changed:', item)
      // You can perform any actions based on the checkbox value here
      this.isPurgePatientTabActve = item
    })

    this.archiveForm.get('isRestorePatients').valueChanges.subscribe((item) => {
      console.log('Checkbox value changed:', item)
      // You can perform any actions based on the checkbox value here
      this.isRestorePatientsActive = item
    })

    this.archiveForm.get('isAdult').valueChanges.subscribe((item) => {
      console.log('Checkbox value changed:', item)
      // You can perform any actions based on the checkbox value here
      this.configurationforAdultorPed = item == true ? 'Adult' : 'Peds'
    })

    this.archiveForm.get('enablePedsConfig').valueChanges.subscribe((item) => {
      console.log('Checkbox value changed:', item)
      // You can perform any actions based on the checkbox value here
      this.isEnablePedsConfigActive = item
    })
  }
  loadTemplates() {
    this.patientarchiveservice
      .patientArchiveGetClinicalArchiveTemplates({})
      .subscribe((result) => {
        this.clinicalTemplate = result.clinicalSettings
        this.billingTemplate = result.billingSettings
        this.significantTemplate = result.significantSettings

        this.loadArchiveSettings()
      })
  }

  loadArchiveSettings() {
    this.patientarchiveservice
      .patientArchiveGet({})
      .pipe(filter((i) => !!i))
      .subscribe((result) => {
        this.SetTemplateSettings(result)

        if (
          result?.billingArchiveByName?.toLowerCase().indexOf('inactivity') > -1
        ) {
          this.SetThresholdFromDbdrivenbilling(result.billingArchiveByName)
        }
        if (
          result?.clinicalArchiveByName?.toLowerCase().indexOf('inactivity') >
          -1
        ) {
          this.SetThresholdFromDbdrivenclinical(result.clinicalArchiveByName)
        }
        debugger
        //console.log(this.archiveForm.patchValue(result))

        //   alert(result.billingArchiveByName);

        this.archiveForm.patchValue(result)

        this.isPurgePatientTabActve = result?.isPurgePatients
        this.isRestorePatientsActive = result?.isRestorePatients
        this.isEnablePedsConfigActive = result?.enablePedsConfig
        this.archiveForm
          .get('billingArchiveByName')
          .setValue(result?.billingArchiveByName.trim())
      })
  }

  SetTemplateSettings(result) {
    debugger
    //for clinical start
    if (
      result?.clinicalSettings != null &&
      result?.clinicalSettings.length > 0
    ) {
      var SavedItems = result.clinicalSettings.split(',')
      let filteredList = []
      this.clinicalTemplate.forEach(function (item) {
        for (let i = 0; i < SavedItems.length; i++) {
          if (SavedItems[i]) {
            if (SavedItems[i].toString().indexOf(item.value) > -1) {
              filteredList.push(item)
              break
            }
          }
        }
      })

      result.clinicalSettings = filteredList
    }
    //for clinical end
    //for billing start
    if (result?.billingSettings != null && result?.billingSettings.length > 0) {
      var SavedItems = result.billingSettings.split(',')
      let filteredList = []
      this.billingTemplate.forEach(function (item) {
        for (let i = 0; i < SavedItems.length; i++) {
          if (SavedItems[i]) {
            if (SavedItems[i].toString().indexOf(item.value) > -1) {
              filteredList.push(item)
              break
            }
          }
        }
      })

      result.billingSettings = filteredList
    }
    //for billing end
    //for significant start
    if (
      result?.significantSettings != null &&
      result?.significantSettings.length > 0
    ) {
      var SavedItems = result.significantSettings.split(',')
      let filteredList = []
      this.significantTemplate.forEach(function (item) {
        for (let i = 0; i < SavedItems.length; i++) {
          if (SavedItems[i]) {
            if (SavedItems[i].toString().indexOf(item.value) > -1) {
              filteredList.push(item)
              break
            }
          }
        }
      })

      result.significantSettings = filteredList
    }
    //for significant end
  }
  SetThresholdFromDbdrivenbilling(obj) {
    debugger
    if (obj == 'InActivity') {
      this.showthreshholdBilling = true
    } else {
      this.showthreshholdBilling = false
    }
  }

  SetThresholdFromDbdrivenclinical(obj) {
    if (obj == 'InActivity') {
      this.showthreshholdClinical = true
    } else {
      this.showthreshholdClinical = false
    }
  }

  ShowhideThreshold(obj, type): void {
    if (type == 'C') {
      this.archiveBy = obj
      if (obj == 'InActivity') {
        this.showthreshholdClinical = true
      } else {
        this.showthreshholdClinical = false
      }
    } else if (type == 'B') {
      this.billingBy = obj
      if (obj == 'InActivity') {
        this.showthreshholdBilling = true
      } else {
        this.showthreshholdBilling = false
      }
    }
  }
  ShowhideRestoraion(obj) {
    debugger
    this.restoreBy = obj
    if (obj == 'daterange') {
      this.restorehButtonDisabled = true
      this.showrestoreDaterange = true
    } else {
      this.restorehButtonDisabled = false
      this.showrestoreDaterange = false
      this.startdate = ''
      this.enddate = ''
    }
  }

  getpatientList(
    pageNumber: number,
    sortcolumn: string,
    sortorder: string,
  ): void {
    debugger

    var serchtext = ''
    if (this.lastName != '') {
      serchtext = this.lastName
    } else if (this.firstName != '') {
      serchtext = this.firstName
    }

    if (sortcolumn == '' && sortorder == '') {
      sortcolumn = 'fullName'
      sortorder = 'Asc'
    }

    this.patientarchiveservice
      .patientArchiveSearch({
        pageNumber: pageNumber,
        searchText: serchtext,
        dob: this.datePipe.transform(this.dOB, 'MM/dd/yyyy'),
        mrn: this.mRN,
        SortByColumn: sortcolumn,
        SortByDirection: sortorder,
      })
      .subscribe((X) => {
        console.log(X)

          this.archivePatients = X;        
          this.rows = this.archivePatients.pageSize
          if (this.archivePatients.totalRecords > 0) {
              this.showRecords = true
              this.showRecordsArchivePatients = true
          } else {
              this.showRecords = false
              this.showRecordsArchivePatients = false
          }
      })
  }

  nextPage($event: LazyLoadEvent) {
    let pageIndex = $event.first / $event.rows + 1 // Index of the new page if event.page not defined.
    var order = 'Asc'
    if ($event.sortOrder == -1) {
      order = 'Desc'
    }

    this.getpatientList(pageIndex, $event.sortField, order)
  }

  clearpatientList(): void {
    this.lastName = ''
    this.firstName = ''
    this.dOB = null
    this.mRN = ''
    this.Showrecords = false

    this.archivePatients = null

    this.archivePatientPurge = null
  }

  restoreconfirmation(event: Event) {
    debugger
    //if (event.defaultPrevented) return;
    //event.preventDefault();
    this.displaypatientRestoreDialog = false

    this.patientRestorteConfirmatiomDialog = true
    //this.confirmation.confirm({
    //    key: 'delete_confirmation',
    //    message: 'Are you sure you want to restore tonight?',
    //    accept: () => { this.onRestorePatient(this.selectedPatientArchiveId) },
    //});
  }

  restoreconfirmation2(res: string) {
    if (res == 'ok') {
      this.onRestorePatient(this.selectedPatientArchiveId)
    } else {
      this.patientRestorteConfirmatiomDialog = false
    }
  }
  onRestorePatient(ptArchiveId: number): void {
    debugger
    this.patientarchiveservice
      .patientArchiveRestore({
        restoreFlag: 'NO',
        startDate: this.datePipe.transform(this.startdate, 'MM/dd/yyyy'),
        endDate: this.datePipe.transform(this.enddate, 'MM/dd/yyyy'),
        patientArchiveId: ptArchiveId,
        restoreBy: this.restoreBy,
      })
      .subscribe((result) => {
        if (result.status.toLowerCase().indexOf('error') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            detail: result.message,
            summary: 'ERROR',
            life: 5000,
          })
        } else if (result.status.toLowerCase().indexOf('ok') > -1) {
          this.patientRestorteConfirmatiomDialog = false
          this.messageService.add({
            key: 'alertToast',
            severity: 'success',
            detail: 'Restoration queued for nightly process.',
            summary: 'Confirmation',
            life: 6000,
          })

          this.patientRestortedSuccessMessage = true
        }
      })
  }

  SelectedPatient(obj): void {
    this.selectedPatientArchiveId = obj.patientArchiveId
    this.selectedPatientArchiveName = obj.lastName + ' ' + obj.firstName
    this.displaypatientRestoreDialog = true
    debugger
  }
  save() {
    debugger
    if (this.archiveForm.invalid) {
      return
    }

    if (this.archiveForm?.get('clinicalSettings')?.value?.length > 0) {
      const selectedSettings = this.archiveForm.value.clinicalSettings
        .map((s) => s.value)
        .join(',')

      this.archiveForm.patchValue({
        clinicalSettings: selectedSettings,
      })
    } else {
      this.archiveForm.patchValue({
        clinicalSettings: null,
      })
    }

    if (this.archiveForm?.get('billingSettings')?.value?.length > 0) {
      const selectedSettings = this.archiveForm.value.billingSettings
        .map((s) => s.value)
        .join(',')

      this.archiveForm.patchValue({
        billingSettings: selectedSettings,
      })
    } else {
      this.archiveForm.patchValue({
        billingSettings: null,
      })
    }

    if (this.archiveForm?.get('significantSettings')?.value?.length > 0) {
      const selectedSettings = this.archiveForm.value.significantSettings
        .map((s) => s.value)
        .join(',')

      this.archiveForm.patchValue({
        significantSettings: selectedSettings,
      })
    } else {
      this.archiveForm.patchValue({
        significantSettings: null,
      })
    }

    this.patientarchiveservice
      .patientArchivePost({ body: this.archiveForm.value })
      .subscribe((result) => {
        if (result.status.toLowerCase().indexOf('error') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            detail: result.message,
            summary: 'ERROR',
            life: 5000,
          })
        } else if (result.status.toLowerCase().indexOf('ok') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'success',
            detail: result.message,
            summary: 'Confirmation',
            life: 5000,
          })
          this.archiveForm.reset()

          this.loadArchiveSettings()
        }
      })
  }

  ShowhideEnablePedsConfig(obj: string, event: any) {
    console.log(obj)
    console.log('+++++++++++++++++++++++++++++++++++++++++++++++++')
    console.log(event)
    // alert(event.value);
    if (event.value == '1') {
      this.archiveForm.value.isAdult = true
      this.archiveForm.value.isPeds = false
      //  alert(event.value);
    } else {
      //alert(event.value);
      this.archiveForm.value.isAdult = false
      this.archiveForm.value.isPeds = true
    }
  }
  getPatientPurgeList(
    pageNumber: number,
    sortcolumn: string,
    sortorder: string,
  ): void {
    debugger

    var serchtext = ''
    if (this.lastName != '') {
      serchtext = this.lastName
    } else if (this.firstName != '') {
      serchtext = this.firstName
    }

    if (sortcolumn == '' && sortorder == '') {
      sortcolumn = 'fullName'
      sortorder = 'Asc'
    }

      this.patientarchiveservice
          .patientArchivePatientPurgeSearch({
              pageNumber: pageNumber,
              searchText: serchtext,
              dob: this.datePipe.transform(this.dOB, 'MM/dd/yyyy'),
              mrn: this.mRN,
              SortByColumn: sortcolumn,
              SortByDirection: sortorder,
          })
          .subscribe((X) => {
              console.log(X)

              this.archivePatientPurge = X

              if (this.archivePatientPurge.totalRecords > 0) {
                  this.showRecordsArchivePatientsPurge = true
              }
              else {
                  this.showRecordsArchivePatientsPurge = false
              }
              this.rows = this.archivePatientPurge.pageSize
          });
  }

  // Define an array to store selected rows

  // Your existing properties and methods

  // Method to handle row selection
  toggleRowSelection(rowData: any) {
    const index = this.selectedRows.indexOf(rowData)
    if (index === -1) {
      this.selectedRows.push(rowData)
    } else {
      this.selectedRows.splice(index, 1)
    }

    if (this.selectedRows.length === this.archivePatientPurge.data.length) {
      this.ischecked = true
    } else {
      this.ischecked = false
    }
  }

  toggleRowSelectionAll(event: any) {
    // alert("testing");
    if (event.target.checked) {
      // Clear the array if all checkboxes are already checked
      if (this.selectedRows.length === this.archivePatientPurge.data.length) {
        this.selectedRows = []
      } else {
        // Otherwise, add all rows to the array
        this.selectedRows = [...this.archivePatientPurge.data]
      }
    } else {
      this.selectedRows = []
    }
    }

    /**
   *
   * This method sort by Asce or Desc or toggle it the columns fields.
   *
   * paramOuter:: [SortEvent,num]
   * returns ::   [archivePatients]
   *
   */
    customSort(event: SortEvent, num: number)
    {       
        this.archivePatients.data = this.customsort.generalcustomSort(event, this.archivePatients.data);
    }

  doPurgePatients() {
    this.patientPurgeConfirmatiomDialog = true
    //  alert("Patient Purge data?");
    //let patientPurgeIdStr:string;
    //if (this.selectedRows.length === 1) {
    //    patientPurgeIdStr = `${this.selectedRows[0].patientPurgeId}`;
    //}
    //else
    //{
    //    patientPurgeIdStr = this.selectedRows.map(x => `${x.patientPurgeId}#`).join('');
    //}
    ////   console.log(patientPurgeIdStr);
    //debugger
    //this.patientarchiveservice.patientPurgeUpdate({

    //    patientPurgeIds: patientPurgeIdStr
    //})
    //.subscribe(result => {

    //        if (result.status.toLowerCase().indexOf('error') > -1) {

    //            this.messageService.add({ key: 'alertToast', severity: 'error', detail: result.message, summary: 'Confirmation', life: 5000 });
    //        }
    //        else if (result.status.toLowerCase().indexOf('ok') > -1) {

    //            this.messageService.add({
    //                key: 'alertToast', severity: 'info', detail: 'Patients purged!.', summary: 'Confirmation', life: 6000
    //            });

    //        }

    //        this.getPatientPurgeList(1, "fullName", "Asc");
    //    });
    //this.selectedRows = [] = [];
    //this.ischecked = false;
  }

  patientPurgeconfirmation(event: any) {
    console.log(event.target.innerText)
    this.patientPurgeConfirmatiomDialog = true

    if (event.target.innerTex == 'OK') {
      //  alert("HHHHH");
      let patientPurgeIdStr: string
      if (this.selectedRows.length === 1) {
        patientPurgeIdStr = `${this.selectedRows[0].patientPurgeId}`
      } else {
        patientPurgeIdStr = this.selectedRows
          .map((x) => `${x.patientPurgeId}#`)
          .join('')
      }
      //   console.log(patientPurgeIdStr);
      debugger
      this.patientarchiveservice
        .patientArchivePatientPurgeUpdate({
          patientPurgeIds: patientPurgeIdStr,
        })
        .subscribe((result) => {
          if (result.status.toLowerCase().indexOf('error') > -1) {
            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              detail: result.message,
              summary: 'ERROR',
              life: 5000,
            })
          } else if (result.status.toLowerCase().indexOf('ok') > -1) {
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              detail: 'Patients purged!.',
              summary: 'Confirmation',
              life: 6000,
            })
          }

          this.patientPurgeConfirmatiomDialog = false
          this.getPatientPurgeList(1, 'fullName', 'Asc')
        })
    } else {
      //alert("HHHHH");
      let patientPurgeIdStr: string
      if (this.selectedRows.length === 1) {
        patientPurgeIdStr = `${this.selectedRows[0].patientPurgeId}`
      } else {
        patientPurgeIdStr = this.selectedRows
          .map((x) => `${x.patientPurgeId}#`)
          .join('')
      }
      //   console.log(patientPurgeIdStr);
      debugger
      this.patientarchiveservice
        .patientArchivePatientPurgeUpdate({
          patientPurgeIds: patientPurgeIdStr,
        })
        .subscribe((result) => {
          if (result.status.toLowerCase().indexOf('error') > -1) {
            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              detail: result.message,
              summary: 'ERROR',
              life: 5000,
            })
          } else if (result.status.toLowerCase().indexOf('ok') > -1) {
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              detail: 'Patients purged!.',
              summary: 'Confirmation',
              life: 6000,
            })
          }

          this.patientPurgeConfirmatiomDialog = false
          this.getPatientPurgeList(1, 'fullName', 'Asc')
        })
      this.patientPurgeConfirmatiomDialog = false
    }

    this.selectedRows = [] = []
    this.ischecked = false

    console.log(event)
  }

  checkSearchButtonState() {
    if (this.startdate != '' && this.enddate != '') {
      this.restorehButtonDisabled = false
    } else {
      this.restorehButtonDisabled = true
    }
  }
}
